import { AxiosRequestConfig } from 'axios';
import api from './api';
import { IncidentPostRequest, IncidentPostResponsePaginated, IncidentResponsePaginated, IncidentImages, IncidentResponse, IncidentPutRequest } from '../@types/incidentTypes';
import { mapInformationChartDataObject } from '../@types/chartData';

const incidentUrl = '/api/incident_records/';

function getIncidents(config: AxiosRequestConfig) {
	return api.get<IncidentResponsePaginated>(incidentUrl, config);
}

function getIncidentById(id: string, config?: AxiosRequestConfig) {
	return api.get<IncidentResponse>(`${incidentUrl}${id}/`, config);
}

function getIncidentsTileKey(config: AxiosRequestConfig) {
	return api.get<string>(incidentUrl, config);
}

function deleteIncidentById(id: string) {
	return api.delete(`${incidentUrl}${id}/`);
}

function createIncident(incidentData: IncidentPostRequest) {
    return api.post<IncidentPostResponsePaginated | string>(incidentUrl, incidentData);
}

function updateIncident(id: string, updatedIncidentData: IncidentPutRequest) {
	return api.put(`${incidentUrl}${id}/`, updatedIncidentData);
}

function addImagesToIncident(imagens: FormData) {
	return api.post(`${incidentUrl}add_image/`, imagens);
}

function updateImagesOfIncident(imagens: FormData, config?: AxiosRequestConfig) {
	return api.put(`${incidentUrl}update_image/`, imagens, config);
}

function getImagesOfIncident(id: string) {
	return api.get<IncidentImages[]>(`${incidentUrl}get_images/`, 
		{
			params: {
				recordID: id,
			},
		}
	);
}

function getSimplifiedZip(config: AxiosRequestConfig) {
	return api.get(`${incidentUrl}generate_zip_simple/`, 
	{
		...config,
		responseType: 'blob',
	});
}

function getFullZip(config: AxiosRequestConfig) {
	return api.get(`${incidentUrl}generate_zip_full/`, 
	{
		...config,
		responseType: 'blob',
	});
}

function getInformationChartData(config: AxiosRequestConfig) {
	return api.get<mapInformationChartDataObject[]>(`${incidentUrl}map_side_list/`, config);
}

const incidentServices = {
	getIncidents,
	getIncidentById,
	getIncidentsTileKey,
	deleteIncidentById,
	createIncident,
	updateIncident,
	addImagesToIncident,
	updateImagesOfIncident,
	getImagesOfIncident,
	getSimplifiedZip,
	getFullZip,
	getInformationChartData
};

export default incidentServices;